export default __webpack_public_path__ + "static/media/moov-money.80546e41.png";